/** @format */

import {styled} from '@mui/material/styles';
import {Paper} from '@mui/material';

export const StyledPaper = styled(Paper)(({theme}) => ({
  marginTop: theme.spacing(1),
  borderRadius: '8px',
  background: theme.palette.semantic_dark?.surface.inverseSurface,
  padding: theme.spacing(4),
}));
